import { render, staticRenderFns } from "./TelaNova.vue?vue&type=template&id=416a31cb&"
import script from "./TelaNova.vue?vue&type=script&lang=js&"
export * from "./TelaNova.vue?vue&type=script&lang=js&"
import style0 from "./TelaNova.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports